import { MagnifyingGlassIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { useId } from 'react';
import AverageProjectBudget from '@/components/Sherpa/Widgets/AverageProjectBudget';
import AverageProjectGrant from '@/components/Sherpa/Widgets/AverageProjectGrant';
import ClosedOutProjects from '@/components/Sherpa/Widgets/ClosedOutProjects';
import GrantFundsRemaining from '@/components/Sherpa/Widgets/GrantFundsRemaining';
import GrantsSpent from '@/components/Sherpa/Widgets/GrantsSpent';
import ImpactByCounty from '@/components/Sherpa/Widgets/ImpactByCounty';
import MatchingFunds from '@/components/Sherpa/Widgets/Matching Funds';
import ProjectStatusSummary from '@/components/Sherpa/Widgets/ProjectStatusSummary';
import RecentActivities from '@/components/Sherpa/Widgets/RecentActivities';
import TotalGrantees from '@/components/Sherpa/Widgets/TotalGrantees';
import TotalProjects from '@/components/Sherpa/Widgets/TotalProjects';
import YearRule from '@/components/Sherpa/Widgets/YearRule';
import Card from '@/components/UI/Card/index.tsx';
import PieChart from '@/components/UI/Charts/PieChart';

const MarylandSherpa = () => {
  // project summary
  const projectSummary = [
    { status: 'Awarded', _count: '100' },
    { status: 'Inventory', _count: '75' },
    { status: 'Oh-Hold', _count: '40' },
    { status: 'Pending', _count: '20' },
    { status: 'In Construction', _count: '30' },
  ];

  // project by type
  const projectType = {
    label: ['Single Family', 'Duplex', 'Office', 'School'],
    dataSets: [
      { data: 20, color: '#334D6E' },
      { data: 10, color: '#808080' },
      { data: 50, color: '#1F79B8' },
      { data: 40, color: '#0FCA98' },
    ],
  };

  // project by construction type
  const projectConstructionType = {
    label: ['Renovation', 'New Construction', 'Office', 'Historic Renovation'],
    dataSets: [
      { data: 30, color: '#0FCA98' },
      { data: 60, color: '#D9B64E' },
      { data: 20, color: '#F27141' },
      { data: 10, color: '#2B6CB0' },
    ],
  };

  const twoYearData = [
    {
      name: '1910 Eagle Drive Cottage Restoration',
      district: 'Baltimore City',
      totalGrants: '$ 8,102,922',
      timeLeft: '9',
    },
    {
      name: '29th Street Community Center Renovation',
      district: 'Baltimore City',
      totalGrants: '$ 2,727,273',
      timeLeft: '10',
    },
    {
      name: 'Annapolis City Dock.',
      district: 'Anne Arundel',
      totalGrants: '$ 3,121,000',
      timeLeft: '20',
    },
    {
      name: 'Alpha and Beta Houses stabilization',
      district: `Prince George's`,
      totalGrants: '$ 9,329,000',
      timeLeft: '5',
    },
    {
      name: 'African American Graveyard Restoration',
      district: 'Frederick',
      totalGrants: '$ 876,000',
      timeLeft: '8',
    },
    {
      name: 'A.M.E. Church Community Center',
      district: 'Montgomery',
      totalGrants: '$ 432,500',
      timeLeft: '15',
    },
  ];

  const sevenYearData = [
    {
      name: 'BAAM Academic Center',
      district: 'Talbot',
      totalGrants: '$ 560,000',
      timeLeft: '59',
    },
    {
      name: 'Bain 50+ Center',
      district: 'Howard',
      totalGrants: '$ 810,000',
      timeLeft: '22',
    },
    {
      name: 'Baltimore Highlands Trail.',
      district: 'Baltimore County',
      totalGrants: '$ 132,1000',
      timeLeft: '43',
    },
    {
      name: 'Bank Barn at Madison Fields',
      district: 'Montgomery',
      totalGrants: '$ 8,329,000',
      timeLeft: '12',
    },
    {
      name: 'Behavioral Health Crisis Mobile Response Unit',
      district: 'Charles',
      totalGrants: '$ 4,376,000',
      timeLeft: '80',
    },
    {
      name: 'Bittinger Fire Station',
      district: 'Garrett',
      totalGrants: '$ 4,432,500',
      timeLeft: '67',
    },
  ];

  const recentActivities = [
    {
      content: 'New Report has been received',
      date: '9/16/2022  3:30 PM',
      by: 'admin',
    },
    {
      content: 'Project 21 has been hold becouse of low budget',
      date: '19/08/2022  3:30 PM',
      by: 'admin',
    },
    {
      content: 'New Developer has been added to project 31',
      date: '19/08/2022  3:30 PM',
      by: 'admin',
    },
    {
      content: 'Status of project has been chaged to completed',
      date: '19/08/2022  3:30 PM',
      by: 'admin',
    },
    {
      content: 'New Report has been received',
      date: '19/08/2022  3:30 PM',
      by: 'admin',
    },
    {
      content: 'New Developer has been added to project 31',
      date: '19/08/2022  3:30 PM',
      by: 'admin',
    },
    {
      content: 'Status of project has been chaged to completed',
      date: '19/08/2022  3:30 PM',
      by: 'admin',
    },
    {
      content: 'New Report has been received',
      date: '19/08/2022  3:30 PM',
      by: 'admin',
    },
    {
      content: 'Status of project has been chaged to completed',
      date: '19/08/2022  3:30 PM',
      by: 'admin',
    },
    {
      content: 'New Report has been received',
      date: '19/08/2022  3:30 PM',
      by: 'admin',
    },
  ];

  const searchId = useId();

  return (
    <div className='max-w-screen-3xl mx-auto'>
      <section className='grid md:grid-cols-2 xl:grid-cols-4 gap-4'>
        <TotalProjects count={572} />
        <AverageProjectGrant count={'951,370'} />
        <AverageProjectBudget count={'2,123,434'} />
        <ClosedOutProjects count={143} />
      </section>
      <section className='my-4 grid md:grid-cols-2 xl:grid-cols-4 gap-4'>
        <TotalGrantees count={492} />
        <GrantsSpent count={'456,035,555'} />
        <GrantFundsRemaining count={'98,485,976'} />
        <MatchingFunds count={127652010} />
      </section>
      <section className='my-4 grid md:grid-cols-1 xl:grid-cols-2 gap-4'>
        <ProjectStatusSummary projectStatus={projectSummary} />
        <ImpactByCounty />
      </section>
      <section className='my-4 grid md:grid-cols-1 xl:grid-cols-2 gap-4'>
        <Card title='Project By Type'>
          <div className='relative p-5 h-80'>
            <div className='absolute px-5 text-center'>
              <h3 className='text-gray-500 font-bold'>Total Projects</h3>
              <h1 className='m-0'>{120}</h1>
            </div>
            <PieChart chartTitle='Project By Type' labels={projectType?.label} datasets={projectType.dataSets} />
          </div>
        </Card>
        <Card title='Project By Construction Type'>
          <div className='relative p-5 h-80'>
            <div className='absolute px-5 text-center'>
              <h3 className='text-gray-500 font-bold'>Total Projects</h3>
              <h1 className='m-0'>{120}</h1>
            </div>
            <PieChart
              chartTitle='Project By Construction Type'
              labels={projectConstructionType?.label}
              datasets={projectConstructionType.dataSets}
            />
          </div>
        </Card>
      </section>
      <section className='my-4 gap-4'>
        <div className='my-4 col-span-2'>
          <Card title='Project Location'>
            <div className='w-full flex justify-center flex-col items-center h-screen/2'>
              <div className='flex justify-center items-center gap-2 text-primaryColor-normal'>
                <MapPinIcon className='h-8 w-8' />
                <h1>No Projects</h1>
              </div>
              <p>There are no assigned projects to display.</p>
            </div>

            {/* {applicationsList?.length > 0 && (
              <div className="w-full grid grid-cols-6 h-screen/2">
                <div className="col-span-6 w-full border-l p-5">
                  <MapGoogle projectList={applicationsList} />
                </div>
              </div>
            )} */}
          </Card>
        </div>
      </section>
      <section className='mb-4 mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-4'>
        <div className='h-full w-full'>
          <div className='flex flex-cols bg-white items-center rounded-t-md py-4'>
            <div className='border-l-4 p-4 border-green-500'>
              <h3 className='font-bold text-bold  capitalize'>2 Year Rule</h3>
              <small className='text-xs text-gray-400 font-normal'>
                (from the date governor signed the legislation approving the bond bills)
              </small>
            </div>

            <div className='relative rounded-md shadow-sm h-10'>
              <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                <MagnifyingGlassIcon className='h-5 w-5 text-gray-400' aria-hidden='true' />
              </div>
              <input
                type='search'
                name='search'
                id={searchId}
                className='focus:ring-neutralColor-normal focus:border-neutralColor-normal block w-full pl-10 sm:text-sm border-gray-500 rounded-md py-2 focus-visible:border focus-visible:border-primary-normal'
                placeholder='Search'
              />
            </div>
          </div>
          <YearRule data={twoYearData} />
        </div>
        <div className='h-full w-full'>
          <div className='flex flex-cols bg-white items-center rounded-t-md py-4'>
            <div className='border-l-4 p-4 border-green-500'>
              <h3 className='font-bold text-bold  capitalize'>7 Year Rule</h3>
              <small className='text-xs text-gray-400 font-normal'>
                (from the date governor signed the legislation approving the bond bills)
              </small>
            </div>

            <div className='relative rounded-md shadow-sm h-10'>
              <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                <MagnifyingGlassIcon className='h-5 w-5 text-gray-400' aria-hidden='true' />
              </div>
              <input
                type='search'
                name='search'
                id={searchId}
                className='focus:ring-neutralColor-normal focus:border-neutralColor-normal block w-full pl-10 sm:text-sm border-gray-500 rounded-md py-2 focus-visible:border focus-visible:border-primary-normal'
                placeholder='Search'
              />
            </div>
          </div>
          <YearRule data={sevenYearData} />
        </div>
      </section>
      {/* <section className="my-4 grid md:grid-cols-1 xl:grid-cols-2 gap-4"> */}
      <RecentActivities activity={recentActivities} />
      {/* </section> */}
    </div>
  );
};

export default MarylandSherpa;
